/**
 * Created by litao on 2018/10/8.
 */
import de from "element-ui/src/locale/lang/de";

export default (http) => {
    return {
        /**
         * 分页查询
         * @param data
         * @return {*}
         */
        queryByPage(data) {
            return http.json({
                url: `/pro/goods/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            })
        },

        delete(data) {
            return http.json({
                url: `/sys/account/delete`,
                data
            })
        },
        getInfo(data) {
            return http.json({
                url: `/pro/goods/get?id=${data.id}`,
                data
            })
        },
        getOne(data) {
            return http.json({
                url: `/pro/goods/getOne?id=${data.id}`,
                data
            })
        },
        saveInfo(data) {
            return http.json({
                url: `/pro/goods/save`,
                data
            })
        },
        getCheckTime(data) {
            return http.json({
                url: `/pro/goods/getCheckTime`,
                data
            })
        },

        updateCheckPandian(data) {
            return http.json({
                url: `/pro/goods/updateCheckPandian`,
                data
            })
        },

        queryUploadByPage(data) {
            return http.json({
                url: `/dealer/queryUploadByPage`,
                data
            })
        },

        queryCheckOut(data) {
            return http.json({
                url: `/pro/goods/queryCheckOut?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            })
        },

        queryUploadGoodsBySn(data) {
            return http.json({
                url: `/dealer/queryUploadGoodsBySn?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            })
        },


        /**
         * 分页查询
         * @param data
         * @return {*}
         */
        queryAll(data) {
            return http.json({
                url: `/pro/goods/queryAll`,
                data
            })
        },


    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/progoods.js